import { render, staticRenderFns } from "./TechnicalPeople.vue?vue&type=template&id=0cd08b19&scoped=true&"
import script from "./TechnicalPeople.vue?vue&type=script&lang=js&"
export * from "./TechnicalPeople.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalPeople.vue?vue&type=style&index=0&id=0cd08b19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd08b19",
  null
  
)

export default component.exports